import {combineReducers} from "redux";

import themeReducer from "./theme";
import userLoginReducer from "./user/user-login-reducer";
// import createLeagueReducer from "./create-league/index";
import seasonListReducer from "./season-list";
import listLeagueReducer from "./list-all-league";
import listPointSystemReducer from "./list-point-system";
import createPointSystemReducer from "./create-point-system";
import getSeasonReducer from "./seasonreducer/getSeasonReducer";
import playerAreaReducer from "./playerAreaReducer";
import createPlayerReducer from "./playerAreaReducer/createPlayerReducer";
import playerScoresReducer from "./playerAreaReducer/getPlayerScoresReducer";
import scoresReducer from "./playerAreaReducer/getScoresReducer";
import coursesReducer from "./coursesReducer";
import createCourseReducer from "./coursesReducer/createCourseReducer";
import deleteCourseReducer from "./coursesReducer/deleteCourseReducer";
import editCourseReducer from "./coursesReducer/editCourseReducer";
import getSponsorReducer from "./sponsorReducer";
import deleteSponsorReducer from "./sponsorReducer/deleteSponsorReducer";
import editSponsorReducer from "./sponsorReducer/editSponsorReducer";
import createSponsorReducer from "./sponsorReducer/createSponsorReducer";
import newsReducer from "./newsReducer";
import createNewsReducer from "./newsReducer/createNewsReducer";
import editNewsReducer from "./newsReducer/editNewsReducer";
import deleteNewsReducer from "./newsReducer/deleteNewsReducer";
import announcementReducer from "./announcementReducer";
import createAnnouncementReducer from "./announcementReducer/createAnnouncementReducer";
import editAnnouncementReducer from "./announcementReducer/editAnnouncementReducer";
import deleteAnnouncementReducer from "./announcementReducer/deleteAnnouncementReducer";
import listTournamentReducer from "./list-all-tournamnets";
import createTournamentReducer from "./create-tournament-reducer";
import getOneTournamentReducer from "./get-one-tournament";
import updatePlayerStatusReducer from "./update-player-status";
import potyDrawsReducer from "./potyDrawsReducer";
import dashboardAnnouncementsReducer from "./dashboard-reducers/dashboard_announcements_reducers";
import dashboardCalenderReducer from "./dashboard-reducers/dashboard_calender_reducer";
import dashboardNewsReducer from "./dashboard-reducers/dashboard_news_reducer";
import dashboardSponsorsReducer from "./dashboard-reducers/dashboard_sponsors_reducer";
import dashboardLatestPotyReducer from "./dashboard-reducers/dashboard_latest_poty_reducer";
import dashboardCombineLeaderboardReducer from "./dashboard-reducers/dashboard-combine-leaderboard-reducer";
import userDetailsReducer from "./user/user-details-reducer";
import getFrontAndBackCoursesReducer from "./potyDrawsReducer/getFrontAndBackCoursesReducer";
import viewCourseReducer from "./coursesReducer/viewCourseReducer";
import getProjectedScoresByID from "../reducers/leaderboard-reducers/getProjectedScoresByID";
import getPotyTournamentSeason from "./leaderboard-reducers/getPotyTounamentSeasons";
import getMinimalPlayerReducer from "./playerAreaReducer/getMinialPlayerReducer";
import createScoreReducer from "./playerAreaReducer/createScoreReducer";
import smpLeagueReducer from "./smpReducer/smpLeagueReducer";
import createSmpListReducer from "./smpReducer/createSmpListReducer";
import groupsAndTeesReducer from "./smpReducer/groupsAndTeesReducer";
import getCourseParIndex from "./smpReducer/getCourseParIndex";
import submitScoreReducer from "./smpReducer/SubmitSmpScore";
import getScoreReducer from "./smpReducer/getScoreReducer";
import getDmpList from "./dmp-reducer/getDmpList";
import getScoreCardParAndIndex from "./dmp-reducer/getScorecardValue";
import leaguePlayerReducer from "./get-leaguePlayers";
import createDmpListReducer from "./dmp-reducer/createDmpListReducer";
import addDmpPlayersInMatchReducer from "./dmp-reducer/addDmpPlayersInMatchReducer";
import createAdminsAddPlayerScore from "../reducers/potyTornament/createAdminsAddPlayerScore";
import getAllPotyTournamentReducer from "../reducers/potyTornament/getAllPotyTournamentReducer";
import getOneTournament from "../reducers/potyTornament/getOneTournament";
import createPotyReducer from "../reducers/potyTornament/createPotyReducer";
import editLeagueReducer from "../reducers/edit-league";
import createLeagueReducer from "../reducers/create-league";
import updatePointSystemReducer from "../reducers/update-point-system";
import deleteLeagueReducer from "../reducers/delete-league";
import getSmpListReducer from "./smpReducer/getSmpListReducer";
import getSelectedLeagueReducer from "./smpReducer/getSelectedLeagueReducer";
import getSelectedDMPLeagueReducer from "./dmp-reducer/getSelectedDMPLeagueReducer";
import createTeamReducer from "./teamReducer/createTeamReducer";
import deleteTeamReducer from "./teamReducer/deleteTeamReducer";
import editTeamReducer from "./teamReducer/editTeamReducer";
import viewTeamReducer from "./teamReducer/viewTeamReducer";
import teamReducer from "./teamReducer";
import teamRankingReducer from "./teamRankingReducer";

const rootReducer = combineReducers({
    themeReducer,
    userLoginReducer,
    createLeagueReducer,
    editLeagueReducer,
    seasonListReducer,
    listLeagueReducer,
    listPointSystemReducer,
    createPointSystemReducer,
    groupsAndTeesReducer,
    getCourseParIndex,
    submitScoreReducer,
    getScoreReducer,
    updatePointSystemReducer,
    deleteLeagueReducer,
    getSmpListReducer,
    getSelectedLeagueReducer,

    getSeasonReducer,
    playerAreaReducer,
    createPlayerReducer,
    playerScoresReducer,
    scoresReducer,
    coursesReducer,
    createCourseReducer,
    deleteCourseReducer,
    editCourseReducer,
    getSponsorReducer,
    deleteSponsorReducer,
    editSponsorReducer,
    createSponsorReducer,
    newsReducer,
    createNewsReducer,
    editNewsReducer,
    deleteNewsReducer,
    announcementReducer,
    createAnnouncementReducer,
    editAnnouncementReducer,
    deleteAnnouncementReducer,
    listTournamentReducer,
    createTournamentReducer,
    getOneTournamentReducer,
    updatePlayerStatusReducer,
    potyDrawsReducer,
    getFrontAndBackCoursesReducer,
    viewCourseReducer,
    dashboardAnnouncementsReducer,
    dashboardCalenderReducer,
    dashboardNewsReducer,
    dashboardSponsorsReducer,
    dashboardLatestPotyReducer,
    dashboardCombineLeaderboardReducer,
    userDetailsReducer,
    getProjectedScoresByID,
    getPotyTournamentSeason,
    getMinimalPlayerReducer,
    createScoreReducer,

    smpLeagueReducer,
    createSmpListReducer,
    getDmpList,
    getSelectedDMPLeagueReducer,
    leaguePlayerReducer,
    createDmpListReducer,
    getScoreCardParAndIndex,
    addDmpPlayersInMatchReducer,

    createAdminsAddPlayerScore,

    getAllPotyTournamentReducer,
    getOneTournament,
    createPotyReducer,

    createTeamReducer,
    deleteTeamReducer,
    editTeamReducer,
    viewTeamReducer,
    teamReducer,
    teamRankingReducer
});

export default rootReducer;
